'use strict';
import {ReduxListStreamedContainer} from '../../../core-utilities/redux/ReduxListContainer';
import {componentOptions, userTodoListReduxList} from '../../redux/userTodoList';
import {TodoMessageListComponent} from './TodoMessageListComponent';


export const UserTodoMessageList = ReduxListStreamedContainer(
  TodoMessageListComponent,
  userTodoListReduxList,
  componentOptions,
);



// WEBPACK FOOTER //
// ./src/js/todo-messages/components/TodoMessageList/UserTodoMessageList.js